var map = {
	"./017211961.jpg": 3893,
	"./SAM_1153.jpg": 4796,
	"./SAM_1171.jpg": 9187,
	"./SAM_1396.jpg": 8924,
	"./atanasov-chete-stihove.jpg": 6317,
	"./gramota-konkurs.jpg": 5727,
	"./grupa-poeti.jpg": 841,
	"./jeko2.jpg": 4284,
	"./kmeta-zhelev-vrychva-nagrada.jpg": 1988,
	"./nagrada-na-predsedatelq.jpg": 219,
	"./nagrada-ot-oblasten-upravitel.jpg": 8626,
	"./photos2020/20181104_133505.jpg": 9688,
	"./photos2020/20181218_184025.jpg": 803,
	"./photos2020/20190502_183830.jpg": 8005,
	"./photos2020/20190921_164550.jpg": 2015,
	"./photos2020/20190921_164612.jpg": 646,
	"./photos2020/20190921_164628.jpg": 5317,
	"./photos2020/20190921_164650.jpg": 2966,
	"./photos2020/20190921_164717.jpg": 326,
	"./photos2020/20190921_164726.jpg": 5543,
	"./photos2020/20191008_181912.jpg": 1549,
	"./photos2020/20191008_181951.jpg": 5080,
	"./photos2020/20191112_180236.jpg": 9564,
	"./photos2020/20191112_180415.jpg": 682,
	"./photos2020/20191115_093650.jpg": 3502,
	"./photos2020/aqrow_sing.jpg": 8951,
	"./photos2020/iwan_gruew.jpg": 4832,
	"./photos2020/ucheredqvane.jpg": 1428,
	"./poetesata-iwanowa-i-atanasow.jpg": 6131,
	"./poeti v mehanata na stoilov.jpg": 3764,
	"./premiera na kniga na atanasov 2001.jpg": 1660,
	"./rumen-stojanov.jpg": 5304,
	"./snimka-atanasov-za-puls.jpg": 8664,
	"./snimka-chetene-detska-kniga.jpg": 9927,
	"./snimka-jordan-atanasov.jpg": 7019,
	"./snimka-s-kameliq.jpg": 730,
	"./uchrediavane.jpg": 4070,
	"./zhelio-zhelev-chete-litglas.jpg": 7012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6563;